import { StaticResourceDto } from 'api/dto/StaticResource.dto';
import { PageItemApi } from 'api/PageItemApi';
import { PageItemAbstractMapper } from 'mapper/PageItemAbstractMapper';
import { PageItemKindMapper } from 'mapper/PageItemMapper';
import { ImageWidget } from 'model/ImageWidget';
import { PageItemKind } from 'model/PageItemKind';

export class ImageWidgetMapper
  implements PageItemKindMapper<ImageWidget, PageItemApi.ImageWidgetEntry>
{
  constructor() {}

  serialize(model: ImageWidget): PageItemApi.ImageWidgetEntry {
    return {
      ...PageItemAbstractMapper.serialize(model),
      id: model.id,
      position: model.position,
      kind: model.kind,
      image: model.image ? model.image.id : undefined,
      imageNew: model.imageNew ? model.imageNew : undefined,
      width: model.width,
      height: model.height,
      align: model.align,
    };
  }

  deserialize(entry: PageItemApi.ImageWidgetEntry): ImageWidget {
    return {
      ...PageItemAbstractMapper.deserializeShape(entry),
      id: entry.id,
      position: entry.position,
      image: entry.image as StaticResourceDto,
      width: entry.width,
      height: entry.height,
      align: entry.align,
    };
  }

  supportsSerialize(model: ImageWidget): boolean {
    return model.kind === PageItemKind.ImageWidget;
  }

  supportsDeserialize(entry: PageItemApi.ItemEntry): boolean {
    return entry.kind === PageItemKind.ImageWidget;
  }
}
